import { render } from "./FnOps.vue?vue&type=template&id=844586b0"
import script from "./FnOps.vue?vue&type=script&lang=js"
export * from "./FnOps.vue?vue&type=script&lang=js"

import exportComponent from "e:\\AiGreate\\tmp\\vertex\\webui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__